/**
 * Capture UTM parameters from the URL on first arrival, stash them in sessionStorage.
 * Subsequent forms/downloads can pull them back out with getUtmAttribution().
 */

const KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];
const STORAGE_KEY = "cb_utm";
const REFERRER_KEY = "cb_referrer";

export function captureUtmFromUrl() {
  if (typeof window === "undefined") return;
  const params = new URLSearchParams(window.location.search);
  const captured = {};
  let hasAny = false;
  for (const k of KEYS) {
    const v = params.get(k);
    if (v) {
      captured[k] = v.slice(0, 200);
      hasAny = true;
    }
  }
  if (hasAny) {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(captured));
    } catch { /* storage blocked — ignore */ }
  }
  // Referrer is a one-shot: capture on first page load only
  try {
    if (!sessionStorage.getItem(REFERRER_KEY) && document.referrer && !document.referrer.includes(window.location.host)) {
      sessionStorage.setItem(REFERRER_KEY, document.referrer.slice(0, 300));
    }
  } catch { /* ignore */ }
}

export function getUtmAttribution() {
  if (typeof window === "undefined") return {};
  let utm = {};
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (raw) utm = JSON.parse(raw);
  } catch { /* ignore */ }
  let referrer = null;
  try {
    referrer = sessionStorage.getItem(REFERRER_KEY);
  } catch { /* ignore */ }
  return { ...utm, referrer };
}
